import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const ShippingIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="m16 9.365-3.407 5.11H2.031l3.407-5.11z" />
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M5.438 14.475v8.858h21.124v-8.858M16 23.333V9.365"
    />
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M19.407 14.475 16 9.365h10.562l3.407 5.11z" />
  </IconV2>
);

export default ShippingIcon;
